import { Tabs } from '@mantine/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AnnualAbstractsOverview } from '@/module/AnnualReport/items/AnnualAbstractsOverview';
import { AnnualArticlesOverview } from '@/module/AnnualReport/items/AnnualArticlesOverview';
import { AnnualAwardsOverview } from '@/module/AnnualReport/items/AnnualAwardsOverview';
import { AnnualPatentsOverview } from '@/module/AnnualReport/items/AnnualPatentsOverview';
import { AnnualProjectsOverview } from '@/module/AnnualReport/items/AnnualProjectsOverview';
import { AnnualTechnologicalTransfersOverview } from '@/module/AnnualReport/items/AnnualTechnologicalTransfersOverview';
import { AnnualTextsOverview } from '@/module/AnnualReport/items/AnnualTextsOverview';
import {
  AnnualReportAwards,
  AnnualReportOverviewCount,
  AnnualReportPapers,
  AnnualReportPatents,
  AnnualReportProjects,
  AnnualReportTechnologicalTransfers,
  AnnualReportTexts,
} from '@/module/AnnualReport/model/AnnualReportTypes';

interface AnnualReportOverviewProps {
  year: number;
  papers: AnnualReportPapers;
  projects: AnnualReportProjects;
  texts: AnnualReportTexts;
  patents: AnnualReportPatents;
  technologicalTransfers: AnnualReportTechnologicalTransfers;
  awards: AnnualReportAwards;

  count: AnnualReportOverviewCount;
}

export function AnnualReportTabs(props: AnnualReportOverviewProps) {
  const { awards, projects, papers, patents, technologicalTransfers, texts, count, year } = props;

  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<string | null>('articles');

  return (
    <Tabs
      value={activeTab}
      onChange={setActiveTab}
    >
      <Tabs.List>
        <Tabs.Tab value="articles">
          {t('annualReport.overviewTabs.articles')} ({count?.papersCount?.articlesCount?.totalCount})
        </Tabs.Tab>
        <Tabs.Tab value="abstracts">
          {t('annualReport.overviewTabs.abstracts')} ({count?.papersCount?.abstractsCount?.totalCount})
        </Tabs.Tab>
        <Tabs.Tab value="projects">
          {t('annualReport.overviewTabs.projects')} ({count?.projectsCount?.totalCount})
        </Tabs.Tab>
        <Tabs.Tab value="texts">
          {t('annualReport.overviewTabs.texts')} ({count?.textsCount?.totalCount})
        </Tabs.Tab>
        <Tabs.Tab value="patents">
          {t('annualReport.overviewTabs.patents')} ({patents?.patents?.length})
        </Tabs.Tab>
        <Tabs.Tab value="technologicalTransfers">
          {t('annualReport.overviewTabs.technologicalTransfers')} (
          {technologicalTransfers?.technologicalTransfers?.length})
        </Tabs.Tab>
        <Tabs.Tab value="awards">
          {t('annualReport.overviewTabs.awards')} ({awards?.awards?.length})
        </Tabs.Tab>
      </Tabs.List>

      <Tabs.Panel value="articles">
        {activeTab === 'articles' && <AnnualArticlesOverview articles={papers.articles} />}
      </Tabs.Panel>
      <Tabs.Panel value="abstracts">
        {activeTab === 'abstracts' && <AnnualAbstractsOverview abstracts={papers.abstracts} />}
      </Tabs.Panel>
      <Tabs.Panel value="projects">
        {activeTab === 'projects' && (
          <AnnualProjectsOverview
            projects={projects}
            year={year}
          />
        )}
      </Tabs.Panel>
      <Tabs.Panel value="texts">{activeTab === 'texts' && <AnnualTextsOverview texts={texts} />}</Tabs.Panel>
      <Tabs.Panel value="patents">{activeTab === 'patents' && <AnnualPatentsOverview patents={patents} />}</Tabs.Panel>
      <Tabs.Panel value="technologicalTransfers">
        {activeTab === 'technologicalTransfers' && (
          <AnnualTechnologicalTransfersOverview technologicalTransfers={technologicalTransfers} />
        )}
      </Tabs.Panel>
      <Tabs.Panel value="awards">{activeTab === 'awards' && <AnnualAwardsOverview awards={awards} />}</Tabs.Panel>
    </Tabs>
  );
}
